import React from "react";
import Particles from "react-particles-js";
import Progress from "components/progress";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import ThemeContext from "../../context";
import "./styles.scss";

class Hero extends React.Component {
  static contextType = ThemeContext;

  render() {
    return (
      <section
        id={`${this.props.id}`}
        className="about"
        style={{ height: this.context.height }}
      >
        {this.particles()}
        <Row>
          <Col md={6} className="content">
            <div className="content-text">
              <div className="line-text">
                <h4>About Me</h4>
              </div>
              <h3>I'm a frontend web3 developer working from home</h3>
              <div className="separator" />
              <p>
                A Frontend and Web3 developer with 3+ years of experience
                designing and building responsive web design and mobile apps in
                different industry. Proficient with CSS and JS Frameworks, with
                extensive knowledge of UX and user psychology. Notable
                achievements include boosting the conversion rate of an existing
                website by 80% with improved code and design.
              </p>
              <div className="social social_icons">
                <FontAwesomeIcon
                  icon={faGithub}
                  className="social_icon"
                  onClick={() => window.open("https://github.com/Ghostsmaw")}
                />
                <FontAwesomeIcon
                  icon={faTwitter}
                  className="social_icon"
                  onClick={() => window.open("https://twitter.com/ghostsmaw")}
                />
                {/* <FontAwesomeIcon icon={faYoutube} className="social_icon" onClick={() => window.open('https://www.youtube.com')} /> */}
                <FontAwesomeIcon
                  icon={faLinkedin}
                  className="social_icon"
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/in/williams-peter-4b8bb4177/"
                    )
                  }
                />
              </div>
            </div>
          </Col>
          <Col md={6} className="skills">
            <div className="line-text">
              <h4>My Skills</h4>
            </div>
            <div className="skills-container">
              <Progress name="HTML & CSS" value={90} delay={1100} />
              <Progress name="Javascript" value={95} delay={1100} />
              <Progress name="ReactJs" value={90} delay={1100} />
              <Progress name="NextJs" value={60} delay={1100} />
              <Progress name="Material UI" value={90} delay={1100} />
              <Progress name="CSS Frameworks" value={70} delay={1100} />
              <Progress name="Git" value={100} delay={1100} />
              <Progress name="Webflow" value={70} delay={1100} />
              <Progress name="Problem Solving" value={100} delay={1100} />
              <Progress name="Critical Thinking" value={100} delay={1100} />
            </div>
          </Col>
        </Row>
      </section>
    );
  }

  particles() {
    return (
      <Particles
        className="particles"
        params={{
          particles: {
            number: {
              value: 50,
              density: {
                enable: false,
                value_area: 5000,
              },
            },
            line_linked: {
              enable: true,
              opacity: 0.5,
            },
            size: {
              value: 1,
            },
          },
          retina_detect: true,
        }}
      />
    );
  }
}

export default Hero;
